import { ControllerRenderProps, FieldValues, useFormContext } from "react-hook-form";
import { CheckboxFieldProps } from "./Checkbox.types";
import { FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";
import { OptionSchema } from "@schema-types/types/JourneySchema";
import { CheckedState } from "@radix-ui/react-checkbox";
import CheckboxCard from "@shadcn/components/ui/checkbox-card";
import { Label } from "@shadcn/components/ui/label";

export const Checkbox = ({ config, required, validation, name, disabled, label }: CheckboxFieldProps) => {
  const { control } = useFormContext();
  const validationConfig = getValidationConfig(validation);
  const description = getFieldHelperText(config.helperText, required);

  const defaultValue = config.options.filter((o) => o.isDefault)?.map((o) => o.value);

  return (
    <div className="space-y-3">
      <FormField
        control={control}
        name={name}
        defaultValue={defaultValue}
        rules={{
          ...validationConfig,
          required: {
            value: required,
            message: "This is a required field",
          },
        }}
        render={({ field }) => (
          <FormItem className="space-y-2">
            {label && <Label htmlFor={name}>{label}</Label>}
            <FormMessage />
            <div>
              <input type="hidden" {...field} id={name} />
              <CheckboxCard
                options={config.options}
                onCheckedChange={(checked, option) => onCheckedChange(field, option, checked)}
                defaultValue={defaultValue}
                value={(field.value as string[]) ?? []}
                disabled={disabled}
              />
            </div>
            {description && <FormDescription>{description}</FormDescription>}
          </FormItem>
        )}
      />
    </div>
  );

  function onCheckedChange(
    field: ControllerRenderProps<FieldValues, string>,
    option: OptionSchema,
    checked: CheckedState
  ) {
    const currentValue = (field.value as string[]) || [];
    return checked
      ? field.onChange([...currentValue, option.value])
      : field.onChange(currentValue?.filter((value: string) => value !== option.value));
  }
};
